import { Disclosure } from "@headlessui/react";
import { MinusCircleIcon, PlusCircleIcon } from "lucide-react";

const ProductFAQCard = ({ question, answer }: { question: string; answer: string | string[] }) => {
	return (
		<Disclosure as="div" className="pt-6">
			{({ open }) => (
				<div className="rounded-lg border px-6 py-4 md:px-10 md:py-8">
					<dt>
						<Disclosure.Button className="flex w-full items-center justify-between text-left text-gray-900">
							<span className="font-semibold text-dark-primary md:text-lg">{question}</span>
							<span className="ml-6 flex h-7 items-center">
								{open ? (
									<MinusCircleIcon
										className="h-8 w-8 fill-brand-primary stroke-white"
										aria-hidden="true"
									/>
								) : (
									<PlusCircleIcon
										className="h-8 w-8 fill-slate-900 stroke-white"
										aria-hidden="true"
									/>
								)}
							</span>
						</Disclosure.Button>
					</dt>
					<Disclosure.Panel as="dd" className="mt-6 pr-12">
						{typeof answer === "object" ? (
							answer.map((point, i) => (
								<p key={i} className="text-lg text-dark-secondary">
									{point}
								</p>
							))
						) : (
							<p className="text-sm text-dark-secondary md:text-base">{answer}</p>
						)}
					</Disclosure.Panel>
				</div>
			)}
		</Disclosure>
	);
};

export default ProductFAQCard;
